// DSP ETA config, sourced from the dataorch external-metadata service
// (GET /metadata/external/{scope}/key/{key}?owners[]=RG_{region}&owners[]=AP_DEFAULT).
export const COURIER_SCOPE = 'APP_COURIER';
export const DEFAULT_OWNER = 'AP_DEFAULT';
export const KEY_ENABLE_DSP_ETA = 'enable_dsp_eta';
export const KEY_DSP_ETA_COUNTDOWN_SECONDS = 'dsp_eta_countdown_seconds';
export const DEFAULT_DSP_ETA_COUNTDOWN_SECONDS = 60;
// Used when the assignment detail omits deliver_by_at_risk_threshold.
export const DEFAULT_DELIVER_BY_AT_RISK_THRESHOLD_MINUTES = 15;
